
import { mixins, Options } from 'vue-class-component'
import { maska } from 'maska'
import AppMixin from '@/components/app/mixins/AppMixin.vue'
import BaseFormMixin from '@/components/common/mixins/BaseFormMixin.vue'
import { IDateRangePicker } from '@/utils/types'
import { Prop } from 'vue-property-decorator'
import moment from 'moment'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import DateRangePicker from 'vue3-daterange-picker'
import { localeData, localeRanges } from '@/utils/datetime'
@Options({
  components: { DateRangePicker },
  directives: { maska },
  emits: ['update:onChangeDateRange', 'update:modelValue'],
})
export default class DateSelectorV2 extends mixins(AppMixin, BaseFormMixin) {
  @Prop()
  modelValue!: string

  @Prop()
  disable!: boolean

  @Prop({ default: 'left' })
  opens!: string

  @Prop()
  displayLabel!: boolean

  @Prop({ default: 150 })
  inputWidth!: number

  @Prop({ default: 24 })
  iconSize!: number

  @Prop({ default: 12 })
  fontSize!: number

  @Prop()
  isClear!: boolean

  @Prop({ default: () => [] })
  rules!: ((val: string) => true | string)[]

  dateFormat = 'YYYY-MM-DD'
  customLocale = localeData(this.dateFormat)
  customRanges = localeRanges()

  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  quasar = useQuasar()

  get value() {
    return this.modelValue
  }

  set value(value) {
    this.$emit('update:modelValue', value)
  }

  get errorMessage() {
    for (const rule of this.rules) {
      const result = rule(this.value)
      if (result !== true) return result
    }
    return ''
  }

  get hasError() {
    return !!this.errorMessage
  }

  onClearDateRangeChange() {
    this.dateRange = {
      startDate: '',
      endDate: '',
    }
    this.value = ''
  }

  formatDate(date) {
    if (date.startDate) {
      const val = moment(date.startDate).format(this.dateFormat)
      return val
    } else {
      return this.dateFormat
    }
  }

  onSelect(data) {
    data.clickApply()
    if (this.dateRange.startDate) {
      this.value = moment(this.dateRange.startDate).format(this.dateFormat)
    } else {
      this.value = ''
    }
  }

  created() {
    // Only set if modelValue (this.value) exists
    if (this.value) {
      this.dateRange.startDate = this.value
    }
  }
}
